module.exports = __webpack_public_path__ + "static/media/whatsapp.969dc850.svg";